
import { ACTION_TYPES } from './Actions';


const initState = {
    toast : {
        enable  : false,
        message : "",
        severity: ""
    }
}

const Reducer = (state = initState, action) => {
    switch (action.type) {

        case ACTION_TYPES.TOAST_MESSAGE_ENABLE:
            return {
                ...state,
                toast : {
                    enable : true,
                    message : action.message,
                    severity : action.severity
                }
            };

        case ACTION_TYPES.TOAST_MESSAGE_DISABLE:
            return {
                ...state,
                toast : {
                    enable : false,
                    message : '',
                    severity : ''
                }
            };

        default:
            return state;
    }
    
}

export default Reducer;